<script>
import { sentenceTrimmer } from 'src/lib/graph/data-lineage/utils.js'

export default {
    data: () => ({
        // A list of distribution id which paths are collapsed
        expandedDis: [],
        collapsedDisId: null,
    }),
    methods: {
        sentenceTrimmer: sentenceTrimmer,
        // Add paths as table within distribution node
        // Label of distribution is the first line of the table
        addPaths(cy) {
            let template = {}
            cy.nodes('.distribution').forEach(node => {
                // Collapse paths by default
                let id = Number(node.data().id)
                if (this.expandedDis.indexOf(id) == -1) {
                    node.data().height = 15
                }
                template = this.addPathToDis(node, template)
            })
            const htmlnode = cy.htmlnode()
            htmlnode.createHtmlNode(this.cytoscape, cy, template)
        },
        // Add paths into distribution node
        addPathToDis(node, template) {
            let nodeId = node.data().id
            let collapseIconClass = this.expandedDis.indexOf(Number(nodeId)) != -1 ? 'fas fa-caret-down fa-lg disCollapse' : 'fas fa-caret-right fa-lg disCollapse'
            if (!(nodeId in this.disPathMap)) {
                collapseIconClass = 'fa fa-blank'
            }
            let baseTemplate = {
                query: `#${node.data().id}`,
                staticZoomLevel: 0.3,
                template: [
                    {
                        zoomRange: [0.3, 100],
                        template: {
                            html: `<table class="pathTable" data-parentdis=${nodeId} style="height: ${node.data().height}px">
                                    <tr class="disLabel">
                                    <th class="pathColumn">
                                    <i class="${collapseIconClass}" data-dis=${nodeId}></i>
                                    <span class="disMainLabel"> ${this.sentenceTrimmer(node.data().name, 35, 25, 10)} </span>
                                    <i class="fas fa-question-circle pull-right helpIcon" data-node=${nodeId} data-tippy-content="Tooltip"></i>
                                    </th>
                                    </tr>`,
                            cssClass: 'htmlCard',
                        }
                    }
                ]
            }
            let subPaths = this.disPathMap[Number(nodeId)]
            if (subPaths && this.expandedDis.indexOf(Number(nodeId)) != -1) {
                baseTemplate.template[0].template.html += `<tr>
                                                            <td>
                                                            <table class="pathSubTable table">
                                                            <tr class="border-bottom">
                                                            <th>Logical path</th>
                                                            <th>Data Type</th>
                                                            <th>Format</th>
                                                            </tr>`
                subPaths.forEach(pathId => {
                    let pathName = this.idPropertyMap[pathId].name
                    baseTemplate.template[0].template.html += `<tr class="border-bottom">
                                                                <td class="pathSubColumn path" data-pathid=${pathId} data-node=${nodeId}>${this.sentenceTrimmer(pathName)}</td>
                                                                <td class="pathSubColumn path" data-pathid=${pathId} data-node=${nodeId}>${this.sentenceTrimmer(this.idPropertyMap[pathId].data_type)}</td>
                                                                <td class="pathSubColumn path" data-pathid=${pathId} data-node=${nodeId}>${this.sentenceTrimmer(this.idPropertyMap[pathId].format)}</td>
                                                               </tr>`
                })
                baseTemplate.template[0].template.html += `</table></td></tr>`
            }
            baseTemplate.template[0].template.html += `</table>`
            template[node.data().id] = baseTemplate
            return template
        },

        // Help function to handle click within distribution:
        // 1. collapse distributions
        // 2. show tooltip for paths
        handleDistributionClick(event) {
            let clickedElement = document.elementFromPoint(event.originalEvent.x, event.originalEvent.y)
            let elementClasses = clickedElement.classList
            if (elementClasses.contains('disCollapse')) {
                this.collapseDistribution(clickedElement)
                this.reRunLayout(this.$refs.cy.instance, true)
            } else if (elementClasses.contains('path')) {
                this.showPathTooltip(clickedElement)
            }
        },

        // Collapse or expand distributions, position cloned path node
        collapseDistribution(collapsedIconElement, distributionId) {
            let disId = distributionId ? distributionId : $(collapsedIconElement).data('dis')
            let cy = this.$refs.cy.instance
            let disNode = cy.nodes(`#${disId}`)
            this.collapsedDisId = disId

            let disTable = document.querySelector(`[data-parentdis="${disId}"]`).parentNode
            disTable.remove()

            disId = Number(disId)
            if (this.expandedDis.indexOf(disId) != -1) {
                // Hide paths
                disNode.data().height = 15
                this.expandedDis.splice(this.expandedDis.indexOf(disId), 1)
            } else if (disId in this.disPathMap) {
                // Show paths
                disNode.data().height = 30 + 15*(this.disPathMap[disId].length) + this.disPathMap[disId].length*2
                this.expandedDis.push(disId)
            }

            disNode.style({'height': disNode.data().height})

            let template = this.addPathToDis(disNode, {})
            const htmlnode = cy.htmlnode()
            htmlnode.createHtmlNode(this.cytoscape, cy, template)
        },
        // Collapse or expand all distributions
        collapseAllDistributions(collapse, fromRebuild) {
            this.ready = false
            let cy = this.$refs.cy.instance
            if (!collapse) {
                // Expand distributions
                this.expandedDis = []
            }
            cy.nodes('.distribution').forEach(node => {
                let nodeId = Number(node.data().id)
                if (collapse) {
                    if (this.expandedDis.indexOf(nodeId) == -1) {
                        this.expandedDis.push(nodeId)
                    }
                }
                this.collapseDistribution(null, nodeId)
            })
            if (!fromRebuild) {
                this.reRunLayout(this.$refs.cy.instance)
            }
            this.ready = true
        },
        // Put virtual node in the path's position, to construct nice path curve
        positionVirtualPathNode(disList, cy, triggeredFromDrag) {
            disList.forEach(disId => {
                let paths = this.disPathMap[disId]
                let disNode = cy.nodes(`#${disId}`)
                for (let index = 0; index < paths.length; index ++) {
                    let pathNode = paths[index]
                    let clonedPath = cy.nodes(`#${pathNode}`)
                    if (clonedPath.data()) {
                        let clonedPathY = disNode.renderedPosition('y')
                        if (paths.length % 2) {
                            // odd
                            let middleIndex = (paths.length + 1) / 2
                            if ((index+2) > middleIndex) {
                                // From the middle points go down (each path will occupy 15px), need to consider border width
                                clonedPathY = clonedPathY + (index+2-middleIndex) * 15 * cy.zoom() + cy.zoom() * (index+2)
                            } else {
                                // From the middle points go up (each path will occupy 15px), need to consider border width
                                clonedPathY = clonedPathY - (middleIndex - (index + 2)) * 15 * (cy.zoom()) - cy.zoom() * (middleIndex - (index + 2))
                            }
                        } else {
                            // even
                            let middleIndex1 = (paths.length) / 2
                            clonedPathY = clonedPathY - (7.5*cy.zoom())
                            if ((index + 2) > (middleIndex1)) {
                                clonedPathY = clonedPathY + (index+2-middleIndex1) * 15 * cy.zoom() + cy.zoom() * (index+2)
                            } else {
                                clonedPathY = clonedPathY - (middleIndex1 - (index+2)) * 15 * (cy.zoom()) - cy.zoom() * (middleIndex1 - (index + 2))
                            }
                        }
                        clonedPath.renderedPosition('x', disNode.renderedPosition('x'))
                        clonedPath.renderedPosition('y', clonedPathY)
                        clonedPath.style({
                            'display': 'element',
                            'opacity': 0,
                        })

                        clonedPath.connectedEdges(edge => {
                            if (!triggeredFromDrag) {
                                // Hide collapsed edge
                                cy.edges(`#${edge.data().sourcePath}${edge.data().targetPath}collapsedlink`).style({
                                    'display': 'none'
                                })
                                // Hide links between distribution nodes, if both distributions are expanded
                                if ((String(disId) == edge.data().sourceDis && this.expandedDis.indexOf(Number(edge.data().targetDis)) != -1) ||
                                    (String(disId) == edge.data().targetDis && this.expandedDis.indexOf(Number(edge.data().sourceDis)) != -1)) {
                                        cy.edges(`#${edge.data().sourcePath}${edge.data().targetPath}srclink`).style({
                                            'display': 'none'
                                        })
                                        cy.edges(`#${edge.data().sourcePath}${edge.data().targetPath}tgtlink`).style({
                                            'display': 'none'
                                        })
                                    }
                                edge.style({
                                    'display': 'element'
                                })
                            }
                            this.adjustEdgeCurve(edge)
                        })

                        // Make virtual node undraggable
                        clonedPath.ungrabify()
                    }
                }
            })
        },
        // Update virtual path position and path link's curvev
        handlePathDrag(disNode) {
            let disId = Number(disNode.data().id)
            let cy = this.$refs.cy.instance

            let disClonedNode = cy.nodes(`#${disNode.data().id}cloned`)
            let connectedClonedDis = disClonedNode.neighborhood()
            connectedClonedDis.forEach(clonedDis => {
                let realDisId = Number(clonedDis.data().clonedData)
                if (this.expandedDis.indexOf(realDisId) != -1) {
                    this.positionVirtualPathNode([realDisId], cy, true)
                }
            })

            if (this.expandedDis.indexOf(disId) != -1) {
                this.positionVirtualPathNode([disId], cy, true)
            }
        },
        // Show path's tooltip on click
        showPathTooltip(clickedElement) {
            let pathId = $(clickedElement).data('pathid')
            let disId = $(clickedElement).data('node')
            // The position of paths within this node, counting from top
            let zoomLevel = this.$refs.cy.instance.zoom()
            let pathPosition = (15*(this.disPathMap[disId].indexOf(pathId) + 3)) * zoomLevel + 15 * zoomLevel /2
            this.clickedPathInfo = this.idPropertyMap[pathId]
            this.addTippyToNode(clickedElement, pathPosition)
        },
    }
}
</script>
